"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;

    const url =
      pathname + (searchParams.toString() ? `?${searchParams.toString()}` : "");

    const GA_ID = process.env.NEXT_PUBLIC_GA_ID || "G-MWJ33YMW8E";
    window.gtag?.("config", GA_ID, {
      page_path: url,
    });
  }, [pathname, searchParams]);

  return null;
}
